import React from 'react';
import { DollarSign, Rocket } from 'lucide-react';

const Earnings = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center animate-in fade-in duration-700">
            <div className="w-24 h-24 bg-primary/10 rounded-[2rem] flex items-center justify-center text-primary mb-8 animate-bounce">
                <DollarSign size={48} />
            </div>
            
            <h1 className="text-4xl font-black text-gray-900 mb-4 tracking-tight">
                Shop Earnings Dashboard
            </h1>
            
            <div className="bg-primary/5 border border-primary/20 px-6 py-2 rounded-full inline-flex items-center gap-2 mb-8">
                <Rocket size={16} className="text-primary" />
                <span className="text-[10px] font-black text-primary uppercase tracking-widest">Coming Soon</span>
            </div>
            
            <p className="text-gray-500 max-w-sm font-medium leading-relaxed text-sm">
                We're building a comprehensive financial suite to help you track shop payouts, 
                analyze sales trends, and manage your business's growth.
            </p>
            
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 w-full max-w-2xl">
                {[
                    { label: 'Real-time Sales', desc: 'Track Every Rupee' },
                    { label: 'Revenue Analytics', desc: 'Growth Insights' },
                    { label: 'Tax Reports', desc: 'GST Simplified' }
                ].map((item, i) => (
                    <div key={i} className="p-6 bg-white rounded-3xl border border-gray-100 shadow-sm opacity-50">
                        <p className="text-xs font-black text-gray-900 mb-1">{item.label}</p>
                        <p className="text-[10px] text-gray-400 font-bold uppercase">{item.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Earnings;
